import * as React from 'react';
import { themr } from 'react-css-themr';
import { EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, GooglePlusIcon, GooglePlusShareButton, LinkedinIcon, LinkedinShareButton, TwitterIcon, TwitterShareButton, WhatsappIcon, WhatsappShareButton, } from 'react-share';
import { resolve } from 'url';
function Item({ platform, url, title, iconSize, round, }) {
    switch (platform) {
        case 'facebook':
            return (React.createElement(FacebookShareButton, { url: url, quote: title },
                React.createElement(FacebookIcon, { size: iconSize, round: round })));
        case 'email':
            return (React.createElement(EmailShareButton, { url: url, subject: title },
                React.createElement(EmailIcon, { size: iconSize, round: round })));
        case 'twitter':
            return (React.createElement(TwitterShareButton, { url: url, title: title },
                React.createElement(TwitterIcon, { size: iconSize, round: round })));
        case 'linkedin':
            return (React.createElement(LinkedinShareButton, { url: url, title: title },
                React.createElement(LinkedinIcon, { size: iconSize, round: round })));
        case 'googlePlus':
            return (React.createElement(GooglePlusShareButton, { url: url },
                React.createElement(GooglePlusIcon, { size: iconSize, round: round })));
        case 'whatsapp':
            return (React.createElement(WhatsappShareButton, { url: url, title: title },
                React.createElement(WhatsappIcon, { size: iconSize, round: round })));
        // case 'pinterest':
        //   return (
        //     <PinterestShareButton url={url} title={title}>
        //       <PinterestIcon size={iconSize} round={round} />
        //     </PinterestShareButton>
        //   )
    }
    return null;
}
function DumpSocialShare({ rootUrl, path, title, iconSize = 32, round, platforms = ['facebook', 'googlePlus', 'email', 'twitter'], theme = {}, }) {
    const url = resolve(rootUrl || '', path);
    return (React.createElement("div", { className: theme.root }, platforms.map(platform => (React.createElement("div", { className: theme.itemWrapper, key: platform },
        React.createElement(Item, { url: url, platform: platform, title: title, iconSize: iconSize, round: round }))))));
}
export const defaultSocialShareTheme = {
    root: 'flex pa2',
    itemWrapper: 'mr2',
};
const SocialShare = themr('SocialShare', {}, { composeTheme: 'softly' })(DumpSocialShare);
export default SocialShare;
//# sourceMappingURL=index.js.map